/*eslint-disable */
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import React, { useEffect, useState } from "react";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import {
  Form as FormUi,
  Container,
  TextArea,
  Button,
  Input,
  Segment,
  Dropdown,
  Icon,
  Search,
  Modal,
} from "semantic-ui-react";
import MyCheckpoint from "../common/myCheckpoint";
import { connect } from "react-redux";
import CreatAxios from "../axiosComponent/create";
import { data } from "jquery";
import { translate } from "react-i18next";

const AddCheckpointModal = ({
  values,
  onClose,
  open,
  handleSubmit,
  addAfter,
  setFieldValue,
  t,
}) => {
  const [addAfterCheckpoint, setaddAfterCheckpoint] = useState([]);
  useEffect(() => {
    console.log(addAfter);
    let dataSet = addAfter.map((item, index) => {
      return {
        key: item.routeManId,
        text: item.checkPointName + " ( " + item.checkPointName + " ) ",
        value: item.sequence,
      };
    });
    setaddAfterCheckpoint(dataSet);
  }, [addAfter]);
  return (
    <React.Fragment>
      <Modal onClose={onClose} open={open} size="mini">
        <Modal.Header className="labelName p-bold-500">
          {t("checkpoint_action_button.add_checkpoint") || "Add Checkpoint"}
        </Modal.Header>
        <>
          <Modal.Content>
            <Formiker>
              <div className="ui form">
                <FormUi.Field>
                  <label className="labelName">{t("checkpoint_table_header.checkpoint_name") || "Checkpoint Name"}</label>
                  <Fieldmik component={MyCheckpoint} name="checkpoint" />
                </FormUi.Field>
                <FormUi.Field>
                  <label className="labelName">{t("checkpoint_table_header.add_after") || "Add After"}</label>
                  <Dropdown
                    name="addAfter"
                    clearable
                    scrolling={true}
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    options={addAfterCheckpoint}
                    className="add-after-route-dropdown"
                    onChange={(name, data) =>
                      setFieldValue("addAfter", +data.value + 1)
                    }
                  />
                </FormUi.Field>
              </div>
            </Formiker>
          </Modal.Content>
          <Modal.Actions>
            <Button size="mini" type="button" onClick={onClose}>
            {t("checkpoint_action_button.cancel") || "Cancel"}
            </Button>
            <Button size="mini" primary onClick={handleSubmit}>
            {t("checkpoint_action_button.save") || "Save"}
            </Button>
          </Modal.Actions>
        </>
      </Modal>
    </React.Fragment>
  );
};
const FormikCheckpoint = withFormik({
  mapPropsToValues: ({ checkpoint, addAfter }) => {
    return {
      checkpoint: checkpoint || "",
      addAfter: addAfter || 1,
    };
  },
  handleSubmit: (values, { props }) => {
    let payload = {
      routeId: props.route_id,
      afterSequence: values.addAfter,
      checkPointId: values.checkpoint,
      eta: "00: 00: 00",
      etd: "00: 00: 00",
      r_eta: "00: 00: 00",
      r_etd: "00: 00: 00",
      sequence: "0",
    };
    console.log(payload);
    CreatAxios({ url: `routeManager`, payload })
      .then((res) => {
        console.log(res);
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.messgae,
        };
        props.successAlert(alert);
        props.onClose();
        window.location.href = "/edit-route";
      })
      .catch((err) => {
        console.log(err);
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: err.data.message,
        };
        props.errorAlert(alert);
        props.onClose();
      });
  },
})(AddCheckpointModal);

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(null, mapDispatchToProps)(translate("route")(FormikCheckpoint));
